import React, { useCallback, useRef } from "react";
import { connect } from "react-redux";

import { faCalendarAlt } from "@fortawesome/pro-solid-svg-icons/faCalendarAlt";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Activity, EntityType } from "@mapmycustomers/shared/types/entity";
import { getPreviewEntityUniqueElementId } from "@mapmycustomers/shared/util/browser";

import ButtonLink from "@app/component/ButtonLink";
import { showEntityView } from "@app/store/entityView/actions";
import { formatRawDateRelative } from "@app/util/formatters";

import styles from "./ActivityItem.module.scss";

interface Props {
  activity: Activity;
  showEntityView: typeof showEntityView;
}

const ActivityItem: React.FC<Props> = ({ activity, showEntityView }) => {
  const ref = useRef<HTMLDivElement>(null);

  const handleSelect = useCallback(() => {
    if (ref.current) {
      showEntityView({
        elementId: getPreviewEntityUniqueElementId(ref.current),
        entityId: activity.id,
        entityType: EntityType.ACTIVITY,
      });
    }
  }, [activity, showEntityView, ref]);

  return (
    <div className={styles.container} ref={ref}>
      <div className={styles.title}>
        <ButtonLink onClick={handleSelect}>{activity.name}</ButtonLink>
      </div>
      <div className={styles.date}>
        <FontAwesomeIcon icon={faCalendarAlt} />{" "}
        {formatRawDateRelative(activity.startAt, Date.now(), "", "PPPPp")}
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  showEntityView,
};

export default connect(null, mapDispatchToProps)(ActivityItem);
